module.exports = __webpack_public_path__ + "static/image24-69629d77b7fe9b420da31aafddafab79.png";